import React, { useState } from "react";
import { ClinicOnboardView } from "./clinicOnboardView";
import { NewPasswordForm } from "user-management/src/components/newPasswordForm";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicForgotPasswordProps {
  gotoSignIn: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicForgotPassword = ({
  ...props
}: ClinicForgotPasswordProps) => {
  const [errMsg, setErrMsg] = useState("");
  return (
    <ClinicOnboardView title="Reset Password" errMsg={errMsg}>
      <NewPasswordForm onResetComplete={props.gotoSignIn} onError={setErrMsg} />
    </ClinicOnboardView>
  );
};
